import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import TVStationOverlayShell from './TVStationOverlayShell';
import TVStationHeatmapCard from './TVStationHeatmapCard';
import { slotsToHeatmap } from '../../utils/tvStationHeatmap';
import tvBroadcast from './tvBroadcastStyles';

function TVStationTodayPanel({ data, compact = false, loading = false }) {
  const { imageSrc, slots, caption, panelTitle } = data;
  const heatmap = useMemo(() => slotsToHeatmap(slots, '今日'), [slots]);

  return (
    <Box sx={{ ...tvBroadcast.root, opacity: loading ? 0.5 : 1 }}>
      <TVStationOverlayShell
        imageSrc={imageSrc}
        title={panelTitle}
        caption={caption}
        compact={compact}
        airy
        contentMaxWidth="min(92%, 980px)"
      >
        <TVStationHeatmapCard
          rowHeader="時間"
          rowLabels={heatmap.rowLabels}
          colLabels={heatmap.colLabels}
          cells={heatmap.cells}
          compact={compact}
          airy
          fillWidth
          sizePreset={compact ? 'stationOverlay' : 'stationOverlayFull'}
        />
      </TVStationOverlayShell>
    </Box>
  );
}

TVStationTodayPanel.propTypes = {
  data: PropTypes.shape({
    locationName: PropTypes.string.isRequired,
    panelTitle: PropTypes.string.isRequired,
    imageSrc: PropTypes.string,
    slots: PropTypes.arrayOf(PropTypes.object).isRequired,
    caption: PropTypes.string.isRequired,
  }).isRequired,
  compact: PropTypes.bool,
  loading: PropTypes.bool,
};

export default TVStationTodayPanel;
